const ModalUtil = (function () {
	var request_id = null;

	var self = {
		openAjax: function (url, selectContent, onOpen, onClose, options) {
			options = $.extend(options, {
				items: {
					type: 'ajax',
					src: url
				}
			});

			self.open(options, selectContent, onOpen, onClose);
		},
		openContent: function ($content, onOpen, onClose, options) {
			options = $.extend(options, {
				items: {
					type: 'inline',
					src: $content
				}
			});

			self.open(options, undefined, onOpen, onClose);
		},
		open: function (options, selectContent, onOpen, onClose) {
			var result_options = $.extend({
				removalDelay: 200,
				mainClass: 'magnific-popup',
				showCloseBtn: false,
				autoFocusLast: false,
				fixedBgPos: true,
				fixedContentPos: true,
				callbacks: {
					open: function () {
						TouchLockUtil.lock(this.wrap);
					},
					parseAjax: function (response) {
						if (selectContent) {
							response.data = selectContent(response.data);
						}
					},
					ajaxContentAdded: function () {
						Update($.magnificPopup.instance.container);

						if (typeof onOpen === 'function') {
							onOpen();
						}
					},
					afterChange: function () {
						setTimeout(function () {
							Update($.magnificPopup.instance.container);

							if (typeof onOpen === 'function') {
								onOpen();
							}
						}, 0);
					},
					close: function () {
						if (typeof onClose === 'function') {
							onClose();
						}
					}
				}
			}, options);

			cancelAnimationFrame(request_id);

			if ($.magnificPopup.instance.isOpen) {
				$.magnificPopup.close();
				setTimeout(function () {
					cancelAnimationFrame(request_id);

					$.magnificPopup.open(result_options);
				}, 200);
			}
			else {
				$.magnificPopup.open(result_options);
			}
		},
		close: function () {
			cancelAnimationFrame(request_id);
			request_id = requestAnimationFrame(function () {
				$.magnificPopup.close();
			});
		}
	};

	$.magnificPopup.instance._onFocusIn = function (e) {
		if ($(e.target).closest('.l-index').length === 0) {
			return true;
		}

		$.magnificPopup.proto._onFocusIn.call(this, e);
	};

	return self;
})();

export default ModalUtil;
